import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { PainSection } from './components/sections/PainSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { VolumeBenefitsSection } from './components/sections/VolumeBenefitsSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { ProductShowcaseSection } from './components/sections/ProductShowcaseSection';
import { AudienceSection } from './components/sections/AudienceSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { OfferSection } from './components/sections/OfferSection';
import { CostSection } from './components/sections/CostSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="6htxpd5ixiv">
      <noscript data-id="element-1" data-mp="2zl39tfhhuw2o">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="2zld43f9knpe6" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="38li619vzxvky" />
      <main data-id="element-4" data-mp="38k6u2msedhir">
        <StatsSection data-id="element-5" data-mp="38kgm0fx05yr3" />
        <ProblemSection data-id="element-6" data-mp="3dkuuu06fhcq6" />
        <PainSection data-id="element-7" data-mp="3dle4yupu6wtn" />
        <SolutionSection data-id="element-8" data-mp="3dlnu6g324zya" />
        <VolumesSection data-id="element-9" data-mp="3dirv2ofh4589" />
        <VolumeBenefitsSection data-id="element-10" data-mp="nvj3xh1mugq9" />
        <BonusesSection data-id="element-11" data-mp="nuhged3fk1rn" />
        <ProductShowcaseSection data-id="element-12" data-mp="nv1284w7baay" />
        <AudienceSection data-id="element-13" data-mp="suncq6knacg2" />
        <ComparisonSection data-id="element-14" data-mp="stuejtzr4v9j" />
        <OfferSection data-id="element-15" data-mp="st2h0dmlgngm" />
        <CostSection data-id="element-16" data-mp="swqbpg3rzfwx" />
        <FaqSection data-id="element-17" data-mp="36859fxwiety" />
        <FinalCtaSection data-id="element-18" data-mp="35ozsypftiwt" />
      </main>
      <PurchasePopup data-id="element-19" data-mp="34nbhsjeuzx5" />
    </div>;
}